<template>
    <div style="height: 100%;">
        <ob-spinner v-if="loadSpinner"></ob-spinner>
        <div class="profile-resume" v-else>
            <template v-if="resumeLink != null && resumeLink != ''">
                <iframe :src="iframeLink"></iframe>
                <div class="options_div">
                    <ob-button type="primary" key="username-download"><a :href="resumeLink"  download style="color:#fff">Download</a></ob-button>
                    <!-- If HR view show Change / Add Resume button -->
                    <ob-button type="secondary"  @click="show = true">Change Resume</ob-button> <!-- v-if="isHRManager" -->
                    <!-- <ob-button type="secondary" v-else-if="$route.params.type != 'onblick'" @click="openChangeResume" key="username-input">Change Resume</ob-button> -->

                </div>
            </template>
            <template v-else>
                <h1 class="noo-resume">No Resume</h1>
                <div class="options_div" style="position:absolute;bottom:0px;">
                    <!-- If HR view show Change / Add Resume button -->
                    <ob-button type="secondary"  @click="show = true">Add Resume</ob-button> <!-- v-if="isHRManager" -->
                    <!-- <ob-button type="secondary" v-else-if="$route.params.type != 'onblick'" @click="openChangeResume" key="uinput">Add Resume</ob-button> -->
                </div>
            </template>
        </div>

        <ob-modal2 :show.sync="show">
            <template slot="modal-title">
                {{resumeHeading}}
            </template>
            <template slot="modal-body">
                <transition name="slide-fade">
                    <ob-upload-new v-if="show" :validation="Validation" :end-point="EndPoint" @file-complete="onFileComplete(...arguments)" @remove-file="ActualResumeLink = ''" :IsFileExists="ActualResumeLink | URL2FileName" :isUploading.sync="isUploading" ref="uploadDocument1">
                        <template slot="file-text">
                            Upload the resume upto 5MB. We accept either PDF or .doc, .docx files.
                        </template>
                    </ob-upload-new>
                </transition>
                <p class="error-msg" v-if="validate && ActualResumeLink == '' && $refs.uploadDocument1 && $refs.uploadDocument1.Errors.length == 0">Please upload the resume</p>
            </template>
            <template slot="modal-footer">
                <!-- <ob-button @click="updateActualResume" :disabled="isUploading">{{ ActualResumeLink == '' ? 'Upload' : 'Update' }}</ob-button> -->
                <ob-button @click="updateActualResume" :disabled="isUploading">Upload</ob-button>
                <ob-button type="secondary" :disabled="isUploading" @click="show=false">Cancel</ob-button>
            </template>
        </ob-modal2>

    </div>
</template>
<script>
import c from '@/components/Core/constants.js'
export default {
  //props: ["consultantDetails"],
  data() {
    return {
      validate: false,
      show: false,
      isUploading: false,
      Validation: {
        Rules: {
          Type: ["pdf", "doc", "docx"],
          Size: 5000000, // In Bytes
          multiplefiles: false
        },
        Messages: {
          Type: "Please upload valid file formats",
          Size: `Please upload a file which is less than 5MB`,
          multiplefiles: "Please select one file"
        }
      },
      EndPoint: `${c.APIBASEURL}/File/FileUpload`,
      ActualResumeLink: "",
      //consultantDetails: "",
      loadSpinner:true
    };
  },
  computed: {
    consultantDetails: {
      get() {
        return this.$store.getters.getConsultantDetails;
      },
      set(value) {
        this.$store.commit("updateConsultantDetails", value);
      }
    },

    iframeLink() {
      let isPDF =
        this.$options.filters
          .URL2FileName(this.resumePreviewLink)
          .toLowerCase()
          .indexOf(".pdf") !== -1;

      let isTXT =
        this.$options.filters
          .URL2FileName(this.resumePreviewLink)
          .toLowerCase()
          .indexOf(".txt") !== -1;

      if (isPDF || isTXT) {
        return `${this.resumePreviewLink}`;
      } else {
        return `https://view.officeapps.live.com/op/embed.aspx?src=${
          this.resumeLink
        }`;
        //return `https://view.officeapps.live.com/op/view.aspx?src=${this.resumeLink}`
      }
    },
    resumeLink() {
      if (this.consultantDetails) {
        if(this.consultantDetails.ResumeLink != null && this.consultantDetails.ResumeLink != '')
          this.consultantDetails.ResumeLink = this.consultantDetails.ResumeLink+'&download=true';
        return this.consultantDetails.ResumeLink;
      }
      return null;
    },
    resumePreviewLink() {
      if (this.consultantDetails) {
        return this.consultantDetails.ResumePreviewLink;
      }
    },
    resumeHeading() {
      if (
        this.consultantDetails != null && this.consultantDetails.ResumeLink != null && this.consultantDetails.ResumeLink != '') {
        return "Change Resume";
      } else {
        return "Add Resume";
      }
    },

    /*isHRViewingW2Candidate() {
      return (
        this.isHRManager &&
        this.$route.query.tax &&
        this.$route.query.tax.toLowerCase() == "w2"
      );
    }*/
  },
  methods: {
    getEmpDetails(){
      ajax.get(`/Employee/${loggedInUserObj.empId}/BasicInfo`, {}, (res) => {
        if(res.data.State == true){
          this.consultantDetails = res.data.Employee
          this.loadSpinner = false
        }
      })
    },
    /*getConsultants() {
      ajax.get(`/Consultant/${loggedInUserObj.empId}/BasicDetail`, {}, res => {
        if (res.data.State == true) {
          this.consultantDetails = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    },*/

    openChangeResume() {
      events.fire("clicked-changeresume");
    },
    updateActualResume() {
      this.validate = true;

      if (this.ActualResumeLink && this.ActualResumeLink != "") {
        if (
          this.resumeLink &&
          this.resumeLink != "" &&
          this.ActualResumeLink == this.resumeLink
        ) {
          this.show = false;
        } else {
          this.show = false;

          this.$loading({ loadingText: "Updating..." });
          ajax.put(
            `/Consultant/UpdateEmployeeActualResume?conId=${loggedInUserObj.consultantId}&hireType=${loggedInUserObj.HireType}&resumeLink=${this.ActualResumeLink}&orgId=${loggedInUserObj.orgId}`,
            {},
            res => {
              this.$loading({ loadingText: "Updating..." }).close();
              if (res.data.State == true) {
                this.$message({
                  type: "success",
                  message: "Resume updated successfully!"
                });

               window.location.reload();
              } else {
                this.ESSEnableDisable(res)
                this.$message({
                  type: "error",
                  message: res.data.Message
                });
              }
            },
            err => {
              this.$loading({ loadingText: "Updating..." }).close();
              this.$message({
                type: "error",
                message: res.data.Message
              });
            }
          );
        }
      }
    },

    // https://github.com/vuejs/vue/issues/5527
    onFileComplete(fileQueue) {
      if (fileQueue[0].response.Url) {
        this.ActualResumeLink = fileQueue[0].response.Url;
      }
    }
  },

  watch: {
    consultantDetails(v) {
      if (v.ResumeLink && v.ResumeLink != "") {
        this.ActualResumeLink = v.ResumeLink;
      } else {
        this.ActualResumeLink = "";
      }
    },
    show(v) {
      if (v == true) {
        this.ActualResumeLink = "";
        this.validate = false;
      }
    }
  },

  created() {
    //this.getConsultants();
    this.getEmpDetails();
    if (this.resumeLink && this.resumeLink != "") {
      this.ActualResumeLink = this.resumeLink;
    }
  }
};
</script>
<style lang="scss">
@import "~styles/framework/vue-utils";

.vue-my-database-page {
  @import "~styles/pages/vue/my-database/components/profile";
}

.noo-resume {
  font-size:25px;
  position: relative;
  top: 35%;
  margin-left: 40%;
}

.error-msg {
  color: $ob-error-red;
  position: absolute;
  font-size: 11px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/EmpResume.vue